require('./ctxTablePagination.style.scss');

/*
    this.state.count        - number of filtered items
    this.state.pageSize     - number of items per page
    this.state.page         - current page
    this.totalEntities      - same as this.state.count
    this.grandTotalEntities - number of items without filter
 */

class CtxTablePaginationController {
    constructor($scope, $filter, $attrs, $element, $timeout, notificationService, dialogService) {
        this.$scope = $scope;
        this.translate = $filter('translate');
        this.$attrs = $attrs;
        this.$element = $element;
        this.$timeout = $timeout;
        this.notificationService = notificationService;
        this.dialogService = dialogService;
        this.dropdownId = 'max-number-of-rows';
        this.$element.on('keydown', (event) => {
            if (event.keyCode === 9 || event.keyCode === 13) {
                let temp = this.tablePaginationEl.find('#' + this.dropdownId);
                if (temp && temp.hasClass('open')) {
                    temp.removeClass('open');
                }
            }
            if (event.keyCode !== 13) return;
            let tempId = document.activeElement.id;
            if (!this.fixPageNumber && (tempId && tempId.toString() === 'custom-page-number-id')) {
                this.customPageSizeSet();
            }
            else
                this.jumpToPage();
        });
    }

    $onInit() {
        this.mainSelected = null;
        this.childSelected = null;
        this.numberOfRowsList = [
            { type: 'value-field', text: this.translate('ctxTablePagination.rows.ten'), value: 10, id: this.$attrs.dropdownListId ? this.$attrs.dropdownListId + '-0' : 0 },
            { type: 'value-field', text: this.translate('ctxTablePagination.rows.twenty'), value: 20, id: this.$attrs.dropdownListId ? this.$attrs.dropdownListId + '-1' : 1 },
            { type: 'value-field', text: this.translate('ctxTablePagination.rows.thirty'), value: 30, id: this.$attrs.dropdownListId ? this.$attrs.dropdownListId + '-2' : 2 },
            { type: 'value-field', text: this.translate('ctxTablePagination.rows.forty'), value: 40, id: this.$attrs.dropdownListId ? this.$attrs.dropdownListId + '-3' : 3 },
            { type: 'value-field', text: this.translate('ctxTablePagination.rows.fifty'), value: 50, id: this.$attrs.dropdownListId ? this.$attrs.dropdownListId + '-4' : 4 },
        ];

        let watchtemp = this.$scope.$watch(() => this.selectionController, ctrl => {
            if (!ctrl) {
                return;
            }
            if (this.showSubSelection && this.subSelectionKey) {
                this.$scope.$watch(() => this.selectionController.selectedItems, selectedItems => {
                    if (!selectedItems) return;
                    this.mainSelected = this.selectionController.selectedItems.filter(x => !x[this.subSelectionKey]).length;
                    this.childSelected = this.selectionController.selectedItems.filter(x => x[this.subSelectionKey]).length;
                });
            }
            watchtemp();
        });

        this.$scope.$watch(() => this.state, state => {
            if (!state) return;
            if (!this.firstTimeAccess && this.defaultValue) {
                state.pageSize = this.defaultValue;
            }
            this.firstTimeAccess = true;
            let tempList = this.numberOfRowsList.filter(item => item.value === state.pageSize);
            this.numberOfRows = tempList[tempList.length - 1];
        });

        this.$scope.$watch(() => this.numberOfRows, (newItem, oldItem) => {
            if (!newItem || (newItem && oldItem && newItem.value === oldItem.value) || !this.state || this.state.pageSize === newItem.value) return;
            if (this.state) {
                this.state.page = 1;
                this.state.pageSize = newItem.value;
                this.onPageChange({ page: this.state.page });
            }
            if (this.numberOfRowsList && this.numberOfRowsList.length) {
                this.lastSelectedIndex = this.numberOfRowsList.indexOf(newItem);
                this.customPageNumber = newItem.value;
            }
        });

        this.tablePaginationEl = this.$element.find('.ctx-table-pagination-content');
        if (this.tablePaginationEl) {
            this.$timeout(() => {
                this.inputPageSizeEl = this.tablePaginationEl.find('#custom-page-number-id');
            }, 1000);
        }

        this.customPageNumberPattern = /^([1-9]|[1-4][0-9]|50)$/;


    }

    $onChanges() {
        this.setPageString();
    }

    onCustomJumpToFocus() {
        this.jumpToInFocus = true;
        let tooltipEl = this.$element.find('.tooltip-info-layout');
        if (tooltipEl && tooltipEl[0]) tooltipEl.remove();
    }

    onCustomJumpToLeave() {
        this.jumpToInFocus = false;
        this.jumpToPage();
    }

    jumpToPage() {
        if (this.previousJumpTo === this.jumpTo) return;
        if (this.validatePageValue()) {
            this.previousJumpTo = this.jumpTo;
            this.onPageChange({ page: this.state.page = this.jumpTo });
        }
    }

    validatePageValue() {
        if (this.jumpTo && Number.isInteger(this.jumpTo) && this.jumpTo > 0 && this.jumpTo <= this.lastPage) {
            return true;
        }
        // wrong input: show warning and reset input value
        let message = {
            type: 'warning',
            title: this.translate('common.form.default.pageSetup.popupNotification.page.title'),
            details: this.translate('common.form.default.pageSetup.popupNotification.page.description', { value: this.lastPage })
        };
        this.notificationService.pop(message);
        this.jumpTo = this.previousJumpTo;
        return false;
    }

    onCustomPageSizeFocus() {
        this.pageSizeInFocus = true;
        let tooltipEl = this.$element.find('.tooltip-info-layout');
        if (tooltipEl && tooltipEl[0]) tooltipEl.remove();
    }

    onCustomPageSizeLeave() {
        this.pageSizeInFocus = false;
        this.customPageSizeSet();
    }

    customPageSizeSet() {
        if (this.previousSize === this.customPageNumber) return;
        if (this.validatePageSizeValue()) {
            this.lastSelectedIndex = null;
            this.numberOfRowsList.forEach((i, index) => {
                if (i.value === this.customPageNumber) {
                    i.isSelected = true;
                    this.lastSelectedIndex = index;
                } else {
                    i.isSelected = false;
                }
            });
            if (this.state) {
                this.state.page = 1;
                this.state.pageSize = this.customPageNumber;
                this.previousSize = this.customPageNumber;
                this.onPageChange({ page: this.state.page });
            }
        }
    }

    validatePageSizeValue(value, customCheck) {
        if (customCheck) this.customPageNumber = value;
        if (this.customPageNumber && Number.isInteger(this.customPageNumber) && this.customPageNumber > 0 && this.customPageNumber <= 50) {
            return true;
        }
        // wrong input: show warning and reset input value
        let message = {
            type: 'warning',
            title: this.translate('common.form.default.pageSetup.popupNotification.pageSize.title'),
            details: this.translate('common.form.default.pageSetup.popupNotification.pageSize.description')
        };
        this.notificationService.pop(message);
        this.customPageNumber = this.previousSize;
        return false;
    }

    onPageClick(direction) {
        let page = 1;

        switch (direction) {
            case 'first':
                page = 1;
                break;
            case 'prev':
                page = this.state.page - 1;
                break;
            case 'next':
                page = this.state.page + 1;
                break;
            case 'last':
                page = Math.ceil(this.state.count / this.state.pageSize);
                break;
            default:
                break;
        }
        this.onPageChange({ page: this.state.page = page });
    }

    setPageString() {
        if (this.fixPageNumber && this.state && this.state.page && this.state.pageSize && this.state.count) {
            let tempLastSelectedIndex = this.state.page * this.state.pageSize;
            this.lastSelectedIndex = tempLastSelectedIndex <= this.state.count ? tempLastSelectedIndex : this.state.count;
        } else {
            this.lastSelectedIndex = this.state ? (this.fixPageNumber ? this.state.count : this.state.page * this.state.pageSize) : 0;
        }
        this.firstSelectedIndex = this.state ? (this.lastSelectedIndex === 0 ? 0 : (this.state.page === 1 ? 1 : (((this.state.page - 1) * (this.state.pageSize)) + 1))) : 0;
        this.totalEntities = this.state ? this.state.count : 0;
        this.grandTotalEntities = this.state ? this.state.countTotal : 0;
        this.jumpTo = this.state && this.state.count !== 0 ? this.state.page : 0;
        this.previousJumpTo = this.jumpTo;
        this.condition = this.state && this.totalEntities !== 0;
        this.lastPage = this.state && this.state.count > 0 && this.state.pageSize > 0 ? Math.ceil(this.state.count / this.state.pageSize) : 0;
        if (this.state && !this.fixPageNumber) {
            this.customPageNumber = this.state.pageSize;
            this.previousSize = this.customPageNumber;
        }
    }

    isBoundary(start) {
        return !this.state ? true : (start ? this.state.page === 1 : this.state.page >= this.lastPage);
    }

    onDropdownOpen() {
        this.openStateFlag = true;
        if (this.inputPageSizeEl) this.inputPageSizeEl.focus();
    }

    onDropdownClose() {
        this.openStateFlag = false;
        if (this.inputPageSizeEl) this.inputPageSizeEl.blur();
    }

    getSelectedValue() {
        return this.selectionController.selectedItems.filter(x => !x.isChild).length;
    }

    onClearItemSelection() {
        if (this.selectionController && this.selectionController.clearAllOnPage) {
            this.selectionController.clearAllOnPage(true);
        }
    }
}

const ctxTablePaginationComponent = {
    controller: CtxTablePaginationController,
    scope: {},
    template: require('./ctxTablePagination.template.html'),
    bindings: {
        state: '<',
        onPageChange: '&',
        fixPageNumber: '<?',
        showPopup: '<?',
        defaultValue: '<',
        showSelected: '<?',
        selectionItems: '<?',
        selectionController: '<?',
        showSubSelection: '<?',
        subSelectionKey: '@?'
    }
};

CtxTablePaginationController.$inject = ['$scope', '$filter', '$attrs', '$element', '$timeout', 'notificationService', 'dialogService'];

module.exports = ctxTablePaginationComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxTablePagination/ctxTablePagination.component.js